import { useNavigate } from "react-router-dom";
import { ChartLineUp, ArrowRight } from "@phosphor-icons/react";
import { Button } from "../ui/button";

export function CTASection({ isDark }) {
  const navigate = useNavigate();

  return (
    <section className={`py-20 px-4 sm:px-6 lg:px-8 ${isDark ? 'bg-gradient-to-b from-[#0c0c16] to-[#0a0a14]' : 'bg-gradient-to-b from-gray-50 to-white'}`}>
      <div className="max-w-4xl mx-auto text-center">
        <div className={`rounded-2xl p-12 ${isDark ? 'bg-gradient-to-r from-purple-900/30 via-purple-800/20 to-purple-900/30 border border-purple-500/20' : 'bg-gradient-to-r from-purple-100 via-purple-50 to-purple-100 border border-purple-200'}`}>
          <ChartLineUp size={48} className="text-purple-500 mx-auto mb-6" weight="duotone" />
          <h2 className={`text-3xl sm:text-4xl font-bold mb-4 ${isDark ? 'text-white' : 'text-gray-900'}`}>
            Ready to Find Your Next Investment?
          </h2>
          <p className={`mb-8 max-w-lg mx-auto ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>
            Get instant access to today's AI-analyzed opportunity with full execution guides.
          </p>
          <Button
            onClick={() => navigate("/dashboard")}
            className="bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-500 hover:to-purple-600 text-white rounded-full px-10 py-6 text-lg font-semibold shadow-lg shadow-purple-500/25"
            data-testid="cta-enter-btn"
          >
            Enter MyQairo
            <ArrowRight size={20} className="ml-2" />
          </Button>
        </div>
      </div>
    </section>
  );
}
